import { vstack } from '@onbeam/business-styled-system/patterns';
import ReactMarkdown from 'react-markdown';
import { mdxComponents } from './MarkdownRenderer.utils';

export const MarkdownRenderer = ({ children }: { children: string }) => (
  <div className={vstack({ gap: '2' })}>
    <ReactMarkdown components={mdxComponents}>{children}</ReactMarkdown>
  </div>
);
